<template>
  <v-dialog v-model="dialog" :persistent="loading">
    <v-card class="pa-2">
      <template v-if="error">
        <alert-prominent :error-message="error" />
        <v-btn color="primary" @click="dialog = false"> Aceptar </v-btn>
      </template>
      <template v-else>
        <template v-if="loading">
          <v-progress-circular indeterminate color="primary" />
        </template>
        <template v-else>
          <v-tabs v-model="tab" background-color="accent-4" center-active dark>
            <v-tab v-if="customerDocs.data.length" :disabled="editMode.value">
              Listado de Solicitudes
            </v-tab>
            <v-tab v-if="!disableRequestForm"
              >{{ editMode.value ? 'Editar' : 'Nueva' }} Solicitud
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-if="customerDocs.data.length">
              <v-card>
                <v-card-text>
                  <h5>Solicitudes realizadas</h5>
                  <v-spacer />
                  <promissory-note-table
                    :items="customerDocs.data"
                    :loading="loading"
                    @editMode="editPromissoryNoteRequest($event)"
                    @destroyPromissory="destroyPromissoryNote($event)"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <promissory-note-form
                    :customer-info="customerInfo"
                    :edit-mode="editMode.value"
                    :promissory-note="editMode.pMNoteRequest"
                    @cancel="cancellableRequest"
                    @requestSubmitted="requestSubmitted"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from '@/plugins/axios';

  import AlertProminent from '@/components/AlertProminent.vue';
  import PromissoryNoteForm from './PromissoryNoteForm.vue';
  import PromissoryNoteTable from './components/PromissoryNoteTable.vue';
  import { Roles } from '@/core/constants/roleConstants';

  export default {
    name: 'CreatePromissoryNote',
    components: { PromissoryNoteForm, PromissoryNoteTable, AlertProminent },
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      customerInfo: {
        type: Object,
        required: true,
        default: () => ({
          userId: '',
          channel: '',
          creditAmount: 0,
          promissoryNoteAmount: 0,
          promissoryNoteDate: null,
          bankGuaranteeName: '',
          customerId: '',
        }),
      },
    },
    data: () => ({
      tab: 0,
      error: '',
      loading: false,
      customerDocs: {
        in_progress: false,
        data: [],
      },
      editMode: {
        value: false,
        pMNoteRequest: {}, //Promissory note request
      },
    }),
    computed: {
      disableRequestForm() {
        if (this.editMode.value) return false;
        return this.customerDocs.in_progress;
      },
      dialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          if (this.value) {
            this.getCustomerDocuments();
          }
          return this.value;
        },
      },
    },
    methods: {
      destroyPromissoryNote(item) {
        this.$swal
          .fire({
            title: '¿Está seguro que desea eliminar esta solicitud?',
            icon: 'warning',
            showCancelButton: true,
            confirmButton: '#66BB6A',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Aceptar',
          })
          .then((result) => {
            if (result.value) {
              this.fetchDestroyPromissoryNote(item.id);
            }
          });
      },
      async fetchDestroyPromissoryNote(id) {
        this.loading = true;
        try {
          await axios.delete(`/promissory-notes/requests/delete/${id}`);
          this.$swal({
            title: 'Solicitud eliminada',
            type: 'success',
          });
          this.getCustomerDocuments();
        } catch (error) {
          this.$swal({
            title: 'Error al eliminar la solicitud',
            type: 'error',
          });
        }
        this.loading = false;
      },
      cancellableRequest() {
        this.disableEditMode();
        this.tab = 0;
        this.dialog = false;
      },
      disableEditMode() {
        this.editMode = {
          value: false,
          pMNoteRequest: {},
        };
      },
      requestSubmitted() {
        this.$emit('requestSubmitted');
        this.customerDocs.in_progress = true;
        this.getCustomerDocuments();
      },
      editPromissoryNoteRequest(pmRequest) {
        this.editMode.pMNoteRequest = pmRequest;
        this.editMode.value = true;
        this.tab = 1;
      },
      async getCustomerDocuments() {
        this.disableEditMode();
        this.error = '';
        this.loading = true;
        try {
          const customerDocs = await axios.get(
            `/promissory-notes/requests/${this.customerInfo.customerId}`,
            {
              cachable: false,
              params: { role: Roles.SELLER },
            }
          );
          this.customerDocs = customerDocs.data;
        } catch (error) {
          this.error =
            'Ha ocurrido un error al recuperar los documentos. Por favor intente más tarde';
        }
        this.loading = false;
      },
    },
  };
</script>
